import { render, staticRenderFns } from "./InvoiceCards.vue?vue&type=template&id=4464f8aa"
import script from "./InvoiceCards.vue?vue&type=script&lang=ts"
export * from "./InvoiceCards.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports